import { computed } from 'vue';

export const useTooltip = (props) => computed<string | null>(() => props.params.tooltip ?? null);
